import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { Toaster } from "sonner";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Scan from "@/pages/Scan";
import Invoices from "@/pages/Invoices";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Clients from "@/pages/Clients";
import Parametres from "@/pages/Parametres";

const Private = ({ children }) => (
  <ProtectedRoute>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Private><Dashboard /></Private>} />
            <Route path="/scanner" element={<Private><Scan /></Private>} />
            <Route path="/factures" element={<Private><Invoices /></Private>} />
            <Route path="/factures/:id" element={<Private><InvoiceDetail /></Private>} />
            <Route path="/clients" element={<Private><Clients /></Private>} />
            <Route path="/parametres" element={<Private><Parametres /></Private>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
